import { render } from "./home.vue?vue&type=template&id=b5f20c6c&scoped=true&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=b5f20c6c&lang=scss&scoped=true"
import "./home.vue?vue&type=style&index=1&id=b5f20c6c&lang=css"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f20c6c"]])

export default __exports__